import {s_char} from "../../_signals/s_char";
import {Item} from "../CharStyled";
import React from "react";

export default function KarmaMax() {
    return <Item>
        <div>Max. Karma</div>
        {s_char.value.karma}
    </Item>
}